import React, { useState } from "react";
import Lottie from "react-lottie";
import ArrowIcon from "../../../../Assets/GettingStartedPage/ArrowIcon.svg";

interface Props {
  title: string;
  description: string;
  animationData: any;
  navigateTo?: string;
}

const GettingStartedStep: React.FC<Props> = ({ title, description, animationData, navigateTo }) => {
  const [isStopped, setIsStopped] = useState(true);
  return (
    <a
      className="flex flex-col min-h-28 max-w-96 items-start border rounded border-gray-200 p-6 hover:border-blue-400 hover:shadow-lg hover:scale-105 transition-transform"
      onMouseEnter={() => setIsStopped(false)}
      onMouseLeave={() => setIsStopped(true)}
      href={navigateTo}
    >
      <div className="mb-4">
        <Lottie
          options={{ animationData, loop: true, autoplay: false }}
          height={74}
          width={64}
          isStopped={isStopped}
          isPaused={false}
        />
      </div>
      <div className="flex justify-center items-center mb-2 text-lg">
        {title}
        <img className={`${isStopped ? "ml-2" : "ml-3"} w-4 h-4`} src={ArrowIcon} alt="go" />
      </div>
      <div>{description}</div>
    </a>
  );
};

export default GettingStartedStep;
